import RecoverConfirm from './RecoverConfirm';
export default RecoverConfirm;